"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var defaults = {
  id: null,
  name: null,
  hasWriteAccess: false,
  displayName: null
};

var CalendarInfo =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(CalendarInfo, _Record);

  function CalendarInfo() {
    (0, _classCallCheck2.default)(this, CalendarInfo);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CalendarInfo).apply(this, arguments));
  }

  (0, _createClass2.default)(CalendarInfo, null, [{
    key: "from",
    value: function from(json) {
      return new CalendarInfo({
        id: json.id,
        name: json.name,
        hasWriteAccess: json.hasWriteAccess,
        displayName: json.displayName
      });
    }
  }]);
  return CalendarInfo;
}((0, _immutable.Record)(defaults));

exports.default = CalendarInfo;
module.exports = exports.default;